module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('h2', {}, [_vm._v(_vm._s(_vm.resetTitle))]), _vm._v(" "), (_vm.$route.query.token && !_vm.passwordResetSuccess) ? _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitPassword()
      }
    }
  }, [_c('div', {
    staticClass: "form__group"
  }, [_c('p', [_vm._v("Choose a new password")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group form__input-group--full form__input-group--wrap"
  }, [_c('label', {
    staticClass: "form__label--hidden",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("New password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.password),
      expression: "auth.password"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.password.$error
    },
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.auth.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.password = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('password')
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label--hidden",
    attrs: {
      "for": "passwordConfirm"
    }
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.passwordConfirm),
      expression: "auth.passwordConfirm"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.password.$error
    },
    attrs: {
      "name": "passwordConfirm",
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.auth.passwordConfirm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.passwordConfirm = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('passwordConfirm')
      }]
    }
  }), _vm._v(" "), (_vm.$v.auth.password.$error || _vm.$v.auth.passwordConfirm.$error) ? _c('span', {
    staticClass: "form__help form__help--error"
  }, [_vm._v("\n              Your password must be 8 or more characters. Password confirmation must match password.\n            ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button form__submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Submit\n            ")]), _vm._v(" "), (_vm.authMessage) ? _c('p', {
    staticClass: "form__link mr-2"
  }, [_vm._v(_vm._s(_vm.authMessage))]) : _vm._e()])]) : (!_vm.passwordResetSuccess) ? _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitEmail()
      }
    }
  }, [_c('div', {
    staticClass: "form__group"
  }, [_c('p', [_vm._v("Enter your email and we'll send you a link to reset your password")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group form__input-group--full form__input-group--wrap"
  }, [_c('label', {
    staticClass: "form__label--hidden",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.email),
      expression: "auth.email"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.authError
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.auth.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button form__submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Send\n            ")]), _vm._v(" "), (_vm.authMessage) ? _c('p', {
    staticClass: "form__link mr-2"
  }, [_vm._v(_vm._s(_vm.authMessage))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "form__link mr-2",
    attrs: {
      "to": {
        name: 'view-login'
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "form__link",
    attrs: {
      "to": {
        name: 'view-register'
      }
    }
  }, [_vm._v("Register")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f29130","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/password-reset.vue
// module id = 229
// module chunks = 1